

export const TutorialStory = {
    level: 1,
    name: 'Magical lessons',
    cpu1Name: 'Adept of Earth',
    cpu2Name: 'Adept of Air',
    cpu3Name: 'Adept of Fire',
    text: "Before starting to explore the world, need to learn how to use magic.",
    classCss: 'map-tutorial-ico',
    cpu1: {
        id: 34,
        before: {
            type: 'skip'
        },
        after: {
            player: {
                type: 'comics',
                comicsSetting:{
                    path: './img/stories/tutorial/1_after_1st_battle/',
                    slideNumber: 5
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Well try again',
                }
            }
        }
    },
    cpu2: {
        id: 35,
        before: {
            type: 'skip',
        },

        after: {
            player: {
                type: 'comics',
                comicsSetting:{
                    path: './img/stories/tutorial/2_after_2nd_battle/',
                    slideNumber: 4
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: "Well try again",
                }
            }
        },
    },
    cpu3: {
        id:36,
        before: {
            type: 'skip',
        },
        after: {
            player: {
                type: 'comics',
                comicsSetting:{
                    path: './img/stories/tutorial/3_after_3th_battle/',
                    slideNumber: 6,
                    animatedSlides: [4]
                }
            },
            cpu: {
                type: 'text',
            step: {
                0: "Well try again",
            }
            }
        },
    }
}